import React from 'react'
import Button from "../Button/Button"
import { LuChevronDown } from "react-icons/lu"
import { TOOLBAR_CONTROL_FORCE_H } from "../Table/toolbarControl"

const OpenModalButton = ({ label, isOpen, setIsOpen, icon: Icon }) => {
  return (
    // Height was never declared here — it fell out of Button's `md` padding and
    // landed on 41px next to a 56px search box. Pinned to the toolbar height.
    <Button width='w-[200px]' size='md' classes={TOOLBAR_CONTROL_FORCE_H}
      type={isOpen ? 'primary' : 'outlined'} onClick={() => setIsOpen(!isOpen)}>
      <div className='flex flex-row justify-between items-center w-full'>
        <span className={`flex items-center gap-2 ${isOpen ? 'text-white' : 'text-text-secondary'}`}>
          {Icon && <Icon size={16} className="shrink-0" />}
          {label}
        </span>
        <LuChevronDown
          size={18}
          className={`transition-transform ${isOpen ? 'rotate-180 text-white' : 'text-text-secondary'}`}
        />
      </div>
    </Button>
  )
}

export default OpenModalButton
